import React, {FC} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

interface Props {
    caption: string;
}

const Error: FC<Props> = ({caption}) => {
  const cls = classNames(
    'feather icon-x-circle'
  );
  return <span className="text-danger">
    <span className={cls}/>
      {caption && " " + caption}
  </span>;
}

export default Error;
